<template>
	<!-- tab 巡检项目 -->
	<div class="cehsi">
		<div class="left_box">
			<div class="left_title">{{$t('label_140')}}</div>
			<el-table :empty-text="$t('label_357')" :data="bjlist" height="calc(100% - 30px)" @current-change="handleCurrentChangeTreeTime" highlight-current-row border style="width: 100%;"
			  :header-cell-style="{'background-color': ' #EFEFEF','color': '#ffffff',}" :show-header="false">
			  <el-table-column header-align="center" align="center" label="No" type="index"
			  	:index="getIndex" width="50">
			  </el-table-column>
			  <el-table-column label="" width="160px">
			    <template slot-scope="scope">
			      {{scope.row.superior}}<br>
			      {{scope.row.tname}} {{scope.row.ename}}<br>
			      {{scope.row.code}}<br>
			    </template>
			  </el-table-column>
			</el-table>
		</div>
		<div class="tableMin" style="height: calc(100% - 100px);margin-left: 20px;">
			<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row height="395px"
				@current-change="handleCurrentChangeTree" style="width: 650px;margin: 5px;border-left: 1px solid #ebeef5;border-right: 1px solid #ebeef5;"
				:header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">

				<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
					width="50">
				</el-table-column>
				<el-table-column prop="name" :label="$t('label_143')" align="left" width="250">
					<template slot-scope="scope">
						<span style="font-size: 16px; font-weight: 600;">
							{{scope.row.name}}
						</span>
						<br>
						<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox>
					</template>
				</el-table-column>
				<el-table-column prop="cycle" :label="$t('label_361')" align="center">
					<template slot-scope="scope">
						<template v-if="scope.row.cycleType=='1'">{{scope.row.cycle=='0'?$t('label_652'):$t('label_531')+scope.row.cycle+$t('label_537')}}</template>
						<template v-if="scope.row.cycleType=='2'">{{scope.row.cycle==0?weekendMesOptions[6].label:weekendMesOptions[scope.row.cycle-1].label}}</template>
						<template v-if="scope.row.cycleType=='3'">{{scope.row.cycle>20?$t('label_238')+scope.row.cycle+$t('label_537'):scope.row.cycle>10?$t('label_242')+scope.row.cycle+$t('label_537'):$t('label_245')+scope.row.cycle+$t('label_537')}}</template>
            <template v-if="scope.row.cycleType=='5'">
              {{$t('label_935')+scope.row.cycle.split(',')[0]+$t('label_540')+scope.row.cycle.split(',')[1]+$t('label_542')+scope.row.cycle.split(',')[2]+$t('label_537')}}
            </template>
          </template>
				</el-table-column>
				<el-table-column prop="method" :label="$t('label_365')" align="center">
					<template slot-scope="scope">
						{{checkText(scope.row.method)}}
					</template>
				</el-table-column>
				<el-table-column prop="defaultValue" :label="$t('label_368')" align="center">
					<template slot-scope="scope">
						<popMesBox :popMes="checkDefaultValue(scope.row.defaultValue)" :hoverMes="checkDefaultValue(scope.row.defaultValue)"
						 :popWidth="200"></popMesBox>
					</template>
				</el-table-column>
				<el-table-column prop="sort1" :label="$t('label_501')" align="center" v-if="showEdit">
					<template slot-scope="scope">
						<el-button @click="moveUp(scope.row, scope.$index)" :disabled="upDisabled(scope.$index)"
							type="text" size="small" style="font-size: 20px"><i class="el-icon-arrow-up"></i>
						</el-button>
						<el-button @click="moveDown(scope.row, scope.$index)" :disabled="downDisabled(scope.$index)"
							type="text" size="small" style="font-size: 20px"><i class="el-icon-arrow-down"></i>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div style="position: absolute;bottom: 2px;left: 40%">
			<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="searchPage"></Page>
		</div> -->
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/checkTree";
	import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
	import file from "@/assets/js/file/file.js";
	import popMesBox from "@/components/list/popover/pop";
	import inspection from "@/assets/js/inspection/inspection.js";

	export default {
		name: 'inspectionProject',
		components: {
			Page,
			tree,
			popMesBox,
		},
		props: {
		  showEdit: {
			type: Boolean,
			default: true
		  }
		},
		data() {
			return {
				bjlist: [],
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				code: '',
				getTreeMes: '1',
				img: '',
				checked: false,
				dialogImg: false,
				dialogVideo: false,
				dialogSpotRemark: false,
				deviceDetailMes: {},
				dialogSpotResult: false,
				MenuRoleList: [],
				newType: {
					id: '',
					remark: ''
				},
				tableData: [],
				tableDataTree: [],
				tableDataTreeInfo: [],
				tableDataInfo: [],
				typeName: '',
				deptName: '',
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checkList: [],
				tableDataTreeTime: [],
				activeNameTree: 'first',
				status: '',
				dateValue: [],
				changeid: '',
				weekendMesOptions: [{
					value: '1',
					label: this.$t('label_719')
				}, {
					value: '2',
					label: this.$t('label_721')
				}, {
					value: '3',
					label: this.$t('label_723')
				}, {
					value: '4',
					label: this.$t('label_725')
				}, {
					value: '5',
					label: this.$t('label_728')
				}, {
					value: '6',
					label: this.$t('label_730')
				}, {
					value: '0',
					label: this.$t('label_716')
				}, ],
				equipmentId: ''
			}
		},
		methods: {
			upDisabled(index) {
				if (index == 0) {
					return true;
				} else {
					return false;
				}
			},
			downDisabled(index) {
				if (index === this.tableData.length - 1) return true;
				else return false;
			},

			changestyle(id) {
				this.changeid = id
			},
			getbjlist() {},
			//获取时间的默认值
			getDate() {
				let start = this.Fungetdate(-7) // 7天前
				let end = this.Fungetdate(0) // 当前时间
				this.dateValue.push(start, end)
				this.Readytime = this.dateValue
			},
			//  当前时间
			Fungetdate(num) {
				var sdd = new Date();
				sdd.setDate(sdd.getDate() + num);
				var yyyy = sdd.getFullYear();
				// var MM = sdd.getMonth() + 1;//获取当前月份的日期
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				var dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				return yyyy + "-" + MM + "-" + dd;
			},
			selechange() {},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			show(id, type) {
				this.img = id;
				if (type == "video") {
					this.dialogVideo = true;
				} else if (type == "photo") {
					this.dialogImg = true;
				}

			},
			// checkDefaultValue(value) {
			// 	let list = JSON.parse(value);
			// 	let text = '';
			// 	var count = 1;
			// 	list.forEach(function(value, index2, array) {
			// 		if (value.check == "1") {
			// 			if (count==1) {
			// 				text += value.name;
			// 			} else {
			// 				text += '，' + value.name;
			// 			}
			// 			count++;
			// 		}
			// 	});
			// 	return text.substring(0, text.length - 1)
			// },
			checkDefaultValue(value) {
				let list = JSON.parse(value);
				let text = '';
				var count = 1;
				list.forEach(function(value, index2, array) {
					if (value.check == "1") {
						if (count==1) {
							text += value.name;
						} else {
							text += '，' + value.name;
						}
						count++;
					}
				});
				return text;
			},
			checkText(type) {
				let typeText = type.toString();
				var data = this.checkList.filter(function(item) {
					return item.key == typeText;
				});
				if (data != '') {
					return data[0].val
				}
			},
			saveRemark() {},
			newTypeSave() {},
			handleClose() {
				this.dialogSpotResult = false;
				this.dialogSpotRemark = false;
			},
			checkResults() {
				this.dialogSpotResult = true
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableDataInfo = info;
				this.equipmentId = this.tableDataInfo.equipmentId;
				this.selectInspInfo(this.tableDataInfo.equipmentId);
			},
			search(param) {},
			searchStauts(param) {},
			searchPage(param) {},
			getDeviceMes(data) {},
			getCheckList() {
        file.getByDictIdALL({dictId: 2, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getCheckList().then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDeviceList(id){
			  let param = {
			    id:id
			  }
			  // this.getcheckList();
			  file.getCheckList().then((response) => {
			  	const data = response.data;
			  	if (data.code == "1") {
			  		this.checkList = data.data;
			  	}
			  }).catch((response) => {
			  	console.log(response)
			  })
			  inspection.selectDevice(param).then((response) => {
			    const data = response.data;
			    if (data.code == "1") {
			      this.bjlist = data.data
				  this.setCurrent(this.bjlist[0]);
			    }
			  }).catch((response) => {
			    console.log(response)
			  })
			},
			moveUp(item, index) {
				inspection.sort2({
					id: item.inspId,
					sort: item.sort1,
					id2: this.tableData[index - 1].inspId,
					sort2: this.tableData[index - 1].sort1
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.selectInspInfo(this.equipmentId);
						this.$emit('reload');
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			moveDown(item, index) {
				inspection.sort2({
					id: item.inspId,
					sort: item.sort1,
					id2: this.tableData[index + 1].inspId,
					sort2: this.tableData[index + 1].sort1
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.selectInspInfo(this.equipmentId);
						this.$emit('reload');
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectInspInfo(param) {
				inspection.selectInspInfo(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			setCurrent(row) {
				this.$refs.singleTable.setCurrentRow(row);
				this.equipmentId = row.equipmentId;
				this.selectInspInfo(row.equipmentId);
			},
		},

		created() {
			this.Fungetdate() // 获取当前时间
			this.getDate() //  设置默认时间
			// this.getcheckList();
			this.search({
				pageNum: 1,
				pageSize: this.pageSize,
			})
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style>
	.cehsi {
		width: 100%;
		height: 370px;
		display: flex;
	}

	.left_box {
		width: 25%;
		max-height: 400px;
		overflow-x: hidden;
		overflow-y: auto;
		border: 1px solid #E1E1E1;
	}

	.left_title {
		width: 100%;
		height: 30px;
		line-height: 30px;
		background: #EFEFEF;
		font-weight: 600;
		padding-left: 30px;
		box-sizing: border-box;
	}

	.content_box {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		padding-left: 30px;
		box-sizing: border-box;
		border: 1px solid #E1E1E1;
	}

	.content_boxs {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		padding-left: 30px;
		box-sizing: border-box;
		border: 2px solid #93D2C1;
	}

	.equipment_wid {
		width: 130px;
		margin-left: 10px;
	}

	.bjmodel {
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/inspectionProject.vue